  const renderWidgetChips = (widgets?: any[]) => {

        // ✅ NULL / UNDEFINED SAFE
        if (!Array.isArray(widgets) || widgets.length === 0) {
            return <span className="text-gray-400">—</span>;
        }

        const MAX_VISIBLE = 3;
        const visible = widgets.slice(0, MAX_VISIBLE);
        const hidden = widgets.slice(MAX_VISIBLE);

        return (
            <div className="flex flex-wrap gap-1 max-w-[220px] relative">
                {visible.map((w, index) => (
                    <span
                        key={`${w.widget_id}-${index}`}
                        className="px-2 py-0.5 text-xs rounded bg-blue-100 text-blue-700 whitespace-nowrap dark:text-slate-100 dark:bg-slate-700"
                    >
                        {/* ✅ NEW payload */}
                        {w}
                    </span>
                ))}

                {hidden.length > 0 && (
                    <div className="relative group">
                        <span className="px-2 py-0.5 text-xs rounded bg-gray-100 text-gray-700 cursor-default dark:text-slate-100 dark:bg-slate-700">
                            +{hidden.length} more
                        </span>

                        <div className="
                        absolute left-0 top-full mt-1
                        hidden group-hover:block
                        z-50
                        min-w-[180px]
                        max-w-[260px]
                        p-2
                        bg-white
                        border
                        rounded
                        shadow-lg
                        dark:text-slate-100 dark:bg-slate-800
                    ">
                            <div className="flex flex-wrap gap-1">
                                {hidden.map((w, index) => (
                                    <span
                                        key={`${index}-hidden-${index}`}
                                        className="px-2 py-0.5 text-xs rounded bg-blue-100 text-blue-800 whitespace-nowrap dark:text-slate-100 dark:bg-slate-700"
                                    >
                                        {w}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

export { renderWidgetChips };